import clsx from 'clsx'
import type { ChangeEvent } from 'react'

import { generateString, validateEmailListInput } from '@fv/client-core'
import type { PropsWithClassName } from '@fv/client-types'

import { Help } from '@/components/Help'
import CheckboxField from '@/components/inputs/CheckboxField'
import { InputGroup } from '@/components/inputs/InputGroup'
import type { ShipmentLocationFormModel } from '@/features/shipment-location-form/types'

type Model = Pick<ShipmentLocationFormModel, 'shares' | 'copyBOL'>

type Props = PropsWithClassName<{
  location: Model
  onChange: (
    value: Pick<ShipmentLocationFormModel, 'copyBOL' | 'shares'>,
  ) => void
}>
export const ShareShipmentWith = ({ location, className, onChange }: Props) => {
  const uniqId = generateString(4)
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    validateEmailListInput(e.target)
    onChange({ shares: e.target.value, copyBOL: location.copyBOL })
  }
  return (
    <>
      <div className={clsx('form-group w-full', className)}>
        <div className="flex items-center">
          <CheckboxField
            checked={location.copyBOL}
            label="Share this shipment with"
            name={`${uniqId}-copyBOL`}
            onChange={e => {
              onChange({ copyBOL: e.target.checked, shares: location.shares })
            }}
          />
          <Help className="ml-1">
            Enter one or more email addresses. We'll send them a link to the
            shipment and subscribe them for tracking updates on the shipment.
          </Help>
        </div>
      </div>

      {location.copyBOL && (
        <InputGroup
          className={clsx('mb-0 mt-4 basis-full', {})}
          inputType="text"
          inputProps={{
            onChange: handleEmailChange,
            name: `${uniqId}-shares`,
            value: location.shares,
            placeholder: 'bill@example.com, ted@example.com',
          }}
        />
      )}
    </>
  )
}
